import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { DetailsSidebarAction, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { SymbolClientAction } from '@cbridge-packages/symbol-client';

type IState =
  IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeSymbolClientBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { clientSymbolName } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);
    if (openedDetailsId === clientSymbolName) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
